import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'amount',
})
export class AmountPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (!value || isNaN(value)) {
            return value;
        }
        let stringVal = '';
        switch (value) {
            case 1:
                stringVal += 'פעם אחת';
                break;
            case 2:
                stringVal += 'פעמיים';
                break;
            default:
                stringVal += value + ' פעמים';
                break;
        }
        return stringVal;
    }
}
